import React, { useRef, useEffect } from 'react'

import { gsap, Power3 } from 'gsap'

import { useStaticQuery, graphql } from 'gatsby'
import Img from "gatsby-image"


import Carousel from 'react-bootstrap/Carousel'
import Button from 'react-bootstrap/Button'



const Showcase = () => {

    let showcaseRef = useRef(null)

        useEffect(() => {
        
        gsap.from(
            showcaseRef,
            1.8,
            {
                duration: 1.8,
                opacity: 0,
                y: -200,
                delay: 1.2,
                ease: Power3.easeOut
            }
            
        )
            
        }, [])
    
    const data = useStaticQuery(graphql`
        query {
            allContentfulSlider {
                edges {
                    node {
                        image1 {
                        fluid(
                            maxWidth: 2500, 
                            quality: 100,
                            ){
                            ...GatsbyContentfulFluid
                        }
                        }
                        image1Title
                        image1Tagline
                        id
                        button1Text
                        }
                }
            }
        }
        `)

    return (
        <section ref={el => { showcaseRef = el }} id="showcase" className="d-flex align-items-center pt-3 pb-5">

            <div className="container">

                <Carousel>

                    { data && data.allContentfulSlider.edges.map((edge) => (

                        <Carousel.Item interval={6000} key={edge.node.id} >
                            <div className="dark-overlay"></div>

                            <Img
                                className="d-block w-100 carousel-img"
                                fluid={edge.node.image1.fluid}
                                key={edge.node.id}
                                alt={edge.node.image1Title}
                                />

                                <Carousel.Caption className="d-none d-md-block py-5">
                                    <h1 className="display-4 font-weight-bold text-uppercase" >{edge.node.image1Title}</h1>
                                    <h3 className="py-3">{edge.node.image1Tagline}</h3>
                                    <Button variant="success" className="btn-lg btn-shadow" href="#mission">
                                        <h4 className="my-0 text-uppercase">{edge.node.button1Text}</h4>
                                    </Button>
                                </Carousel.Caption> 
                                <Carousel.Caption className="d-xs-block d-md-none d-lg-none d-xl-none">
                                    <p className="font-weight-bold text-uppercase">{edge.node.image1Title}</p>
                                    <p>{edge.node.image1Tagline}</p>
                                </Carousel.Caption> 
                        </Carousel.Item>
                    )
                    )}
                    
                </Carousel>
            
            </div>    
        </section>
    )
}

export default Showcase
